import { cx } from "class-variance-authority";
import type React from "react";
import { ReactComponent as Svg } from "./assets/arrow-down-1.svg";
import * as styles from "./Icon.module.scss";

type ChevronRightProps = React.SVGProps<SVGSVGElement>;

export const ChevronRight = ({ className, ...props }: ChevronRightProps) => (
  <Svg className={cx(className ?? styles.base, styles.arrowRight)} {...props} />
);
